<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: SocialButton
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=528-34
 *
 * A social-network round button for the footer. The 44x44 outer box is the click
 * target ONLY (transparent, never shrink it below 44 — WCAG 2.2 AAA / Apple HIG);
 * the visible 32px circle is painted with action/primary/* per state. A row of
 * these takes gap 0 (the 6px transparent padding already spaces the circles) plus
 * margin-inline-start: -6px on the row so the first circle aligns optically.
 * Glyphs are FontAwesome brand icons (the DS Icon registry has no reddit glyph —
 * dsGap). Focus: native ring. No disabled state.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { SocialButtonProps } from '../types/interfaces'
// hooks
import { useSocialButton } from '../composables/use-social-button.hook'
// components
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

defineOptions({
  name: 'SocialButton',
})

const props = defineProps<SocialButtonProps>()

const {
  refIcon,
} = useSocialButton({ props })
</script>

<template>
  <a
    class="social-button"
    :href="url"
    :aria-label="network"
    target="_blank"
    rel="noopener noreferrer"
  >
    <span class="social-button__circle">
      <FontAwesomeIcon
        class="social-button__glyph"
        :icon="refIcon"
      />
    </span>
  </a>
</template>

<style lang="scss" scoped src="../styles/_social-button.scss" />
